import {ImageType} from "react-images-uploading";
import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import {
    addSlide,
    checkIsAllPhotosUploaded,
    setIsAllPhotosUploaded, setOnBoardingShowReorderPopup,
    setSlideUploadProgress
} from "../store/makerDataSlice";
import SlideData, {UploadStatus} from "../Interfaces/SlideData";
import axios, {AxiosProgressEvent} from "axios";
import {getUploadRequestDataUrl} from "./url";
import ym from "react-yandex-metrika";
import {store} from "../store/store";

export default async function uploadPhoto(argsData: any) {

    let image: ImageType = argsData.image;
    let dispatch: Dispatch<AnyAction> = argsData.dispatch;
    let tmpProjectId: string = argsData.tmpProjectId;
    let pid: string = argsData.pid;
    let makerData = argsData.makerData;

    dispatch(setIsAllPhotosUploaded(false));

    dispatch(addSlide({
        pid: pid,
        type: 'photo',
        status: UploadStatus.uploading
    } as SlideData));

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    // получаем action и поля формы для upload'а файла (это может быть сервер sl или yandex object storage
    const response0 = await axios.get(getUploadRequestDataUrl, {
        params: {
            fileName: image['file']?.name,
            tmpProjectId: tmpProjectId,
            pid: pid,
            type: 'photo',
            ...vkLaunchParams
        }
    });

    if (typeof response0.data['error'] !== 'undefined') {
        if (response0.data['error'] === 'wrongFile') {
            throw ({
                message: 'Failed to upload photo. Wrong file. No extension.',
                response: response0,
                responseConfig: JSON.stringify(response0?.config),
                responseData: JSON.stringify(response0?.data),
                url: getUploadRequestDataUrl
            });
        }
    }

    // отправляем форму с файлом
    let data = new FormData()
    for (const [key, value] of Object.entries(response0.data)) {
        if (key === 'action') {
            continue;
        }
        if (key === 'fileFieldName') {
            // @ts-ignore
            data.append(value, image['file'] as Blob, image['file']?.name)
        } else {
            // @ts-ignore
            data.append(key, value)
        }
    }

    const response = await axios.post(response0.data['action'], data, {
        onUploadProgress: function (progressEvent: AxiosProgressEvent) {
            var percentCompleted = progressEvent.total ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0
            dispatch(setSlideUploadProgress({
                pid: pid,
                uploadProgress: percentCompleted
            }));
        },
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    if (response.data.files.length == 1) {
        if (response.data.files[0]?.error == 'Unsupported file.') {
            dispatch(addSlide({
                pid: pid,
                localFileName: image['file']?.name,
                type: 'photo',
                status: UploadStatus.uploadError,
                uploadError: 'Ошибка при загрузке файла'
            } as SlideData));
        } else {
            if (response.data.files[0].size) {
                if (response.data.files[0]?.error) {
                    throw ({
                        message: 'Failed to upload photo. Error in response files.',
                        response: response,
                        responseConfig: JSON.stringify(response?.config),
                        responseData: JSON.stringify(response?.data),
                        url: response0.data['action']
                    });
                }
                await dispatch(addSlide({
                    pid: response.data.files[0].pid,
                    previewId: response.data.files[0].previewId,
                    pathInfoFilename: response.data.files[0].pathInfoFilename,
                    src: response.data.files[0].url,
                    medium_url: response.data.files[0].medium_url,
                    thumbnail_url: response.data.files[0].thumbnail_url,
                    width: response.data.files[0].width,
                    height: response.data.files[0].height,
                    type: 'photo',
                    status: UploadStatus.uploadSuccess,
                    createdAt: Math.round(new Date().getTime() / 1000),
                    createdByUser: true
                } as SlideData));
                const makerData2 = store.getState().makerData;
                if (typeof makerData2.onBoardingShowReorderPopup === 'undefined' && makerData2.currentTab === 'slides') {
                    dispatch(setOnBoardingShowReorderPopup(true));
                }
                dispatch(checkIsAllPhotosUploaded());
                ym('reachGoal', 'addPhotoSlideSuccess');
                return;
            } else {
                throw ({
                    message: 'Failed to upload photo. Error in response.',
                    response: response,
                    responseConfig: JSON.stringify(response?.config),
                    responseData: JSON.stringify(response?.data),
                    url: response0.data['action']
                });
            }
        }
    } else {
        throw ({
            message: 'Failed to upload photo. Wrong response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: response0.data['action']
        });
    }
}